import { memo, useEffect, useState, useCallback } from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';

import { exportAppointmentRequests, resetExportState } from './slice';
import { getCurrentEmployer } from '../../../selectors/employers';

import { __WEB__, THEME } from '../../../constants/styles';

import moment from 'moment';

import { NavBar, Navigation, Container, FormFooter, DatePicker, Utils } from '../../components';
import { REQUESTING } from '../../../actions/statusTypes';

const AppointmentRequestsExportForm = memo((props) => {
  const dispatch = useDispatch();
  const employer = useSelector(getCurrentEmployer);
  const status = useSelector((state) => state.screens.scheduler?.exportStatus);
  const successMessage = useSelector((state) => state.screens.scheduler?.exportSuccessMessage);
  const errorMessage = useSelector((state) => state.screens.scheduler?.exportError);

  useEffect(NavBar.setup(props), []);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [localErrorMessage, setLocalErrorMessage] = useState(null);

  useEffect(() => {
    return () => {
      dispatch(resetExportState());
    };
  }, [dispatch]);

  const handleCancel = useCallback(() => {
    Navigation.dismissAllModals();
  }, []);

  const handleSave = useCallback(() => {
    dispatch(
      exportAppointmentRequests({
        employerId: employer.employerId,
        exportData: {
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
        },
      })
    );
  }, [employer, startDate, endDate, dispatch]);

  const handleStartDate = useCallback((date) => {
    setStartDate(date);
  }, []);

  const handleEndDate = useCallback((date) => {
    setEndDate(date);
  }, []);

  const footer = (
    <FormFooter
      onCancel={handleCancel}
      cancelLabel="Done"
      onSave={handleSave}
      saveDisabled={!startDate || !endDate}
      saveLabel={'Export'}
    />
  );

  return (
    <Container
      scrollView={true}
      stickyFooter={footer}
      style={THEME.container}
      renderActivityOverlay={status === REQUESTING}
      errorMessage={
        (errorMessage && 'Unknown error, please contact Administrator') || localErrorMessage
      }
      successMessage={successMessage}
    >
      <View style={styles.content}>
        <Text style={styles.description}>
          Export CMR appointment requests within the selected date range.
        </Text>
        <View style={styles.formInputs}>
          <DatePicker
            label={'Start Date'}
            validateFunc={Utils.validate.date}
            required={true}
            onDate={handleStartDate}
            selectedDate={startDate}
            flexibleHeight={true}
          />
          <DatePicker
            label={'End Date'}
            validateFunc={Utils.validate.date}
            required={true}
            onDate={handleEndDate}
            selectedDate={endDate}
            flexibleHeight={true}
          />
        </View>
      </View>
    </Container>
  );
});

const styles = StyleSheet.create({
  formInputs: {
    paddingHorizontal: 50,
    alignItems: 'center',
  },
  content: {
    flex: 1,
    paddingBottom: 150,
    justifyContent: 'center',
    paddingVertical: 35,
  },
  description: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 30,
    color: '#666',
  },
});

export default AppointmentRequestsExportForm;
